/** @format */
import { createReducer } from "@reduxjs/toolkit";
import { IAccount } from "lobbie";
import { setAccount, setAccountPublicUuid, setAccounts } from "../actions/accountActions";
import type { RootState } from "../store";

export type AccountReducerStateDef = {
    account?: Partial<IAccount>;
    accounts?: Partial<IAccount>[];
    publicUuid?: string | null;
};
const initialState: AccountReducerStateDef = {
    accounts: [],
    account: undefined,
    publicUuid: undefined,
};

export const accountReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setAccountPublicUuid, (state, action) => {
            return {
                ...state,
                publicUuid: action.payload,
            };
        })
        .addCase(setAccounts, (state, action) => {
            return {
                ...state,
                accounts: action.payload,
            };
        })
        .addCase(setAccount, (state, action) => {
            return {
                ...state,
                account: {
                    ...state.account,
                    ...action.payload,
                },
            };
        });
});

export const currentAccountId = (state: RootState) => state.account?.account?.id;
export const currentAccountPublicUuid = (state: RootState) => state.account?.account?.publicUuid;
